"use client";

import React, { useEffect, useContext, useState } from "react";
import { Accordion } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";

const LeftSidebar = ({ toggleActive }) => {
  const location = useLocation(); // Use `useLocation` to get the current path
  const pathname = location.pathname; // Extract `pathname` from location

  // Enable the dark sidebar exclusively for the /dashboard/beauty-salon/ page URL.
  const [isDark, setIsDark] = useState(false);

  const { user, role, logout } = useContext(AuthContext);

  useEffect(() => {
    // Only check or set the theme if we're on the beauty-salon page.
    if (pathname === "/dashboard/beauty-salon") {
      const storedTheme = localStorage.getItem("beautySalonSidebarTheme");
      if (storedTheme) {
        setIsDark(storedTheme === "dark");
      } else {
        // Default to dark theme and persist it in localStorage
        setIsDark(true);
        localStorage.setItem("beautySalonSidebarTheme", "dark");
      }
    } else {
      // For other pages, do not use localStorage for the theme
      setIsDark(false);
    }
  }, [pathname]);

  // ✅ تعریف منوها بر اساس نقش
  const menuItems = {
    STORE: [
      /*{
        path: "/store/dashboard",
        icon: "dashboard",
        title: "داشبورد فروشگاه",
      },*/
      {
        path: "/store/orders",
        icon: "shopping_bag",
        title: "سفارش‌ها",
      },
      {
        path: "/store/pending-payments",
        icon: "payments",
        title: "پرداخت‌های در انتظار",
      },
      {
        path: "/store/credit-requests",
        icon: "shopping_cart",
        title: "ثبت درخواست خرید",
      },
      {
        path: "/store/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/store/purchase-accounts",
        icon: "account_balance_wallet",
        title: "حساب خرید",
      },
      /*{
        path: "/store/profile",
        icon: "storefront",
        title: "پروفایل فروشگاه",
      },*/
      /*{
        path: "/store/wallet",
        icon: "account_balance_wallet",
        title: "کیف پول فروشگاه",
      },*/
    ],
    USER: [
      /*{
        path: "/user/dashboard",
        icon: "dashboard",
        title: "داشبورد کاربر",
      },*/
      {
        path: "/user/credit-requests",
        icon: "shopping_cart",
        title: "درخواست‌های ثبتی",
      },
      /*{
        path: "/user/wallet",
        icon: "account_balance_wallet",
        title: "کیف پول من",
      },*/
      {
        path: "/user/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/user/purchase-accounts",
        icon: "account_balance_wallet",
        title: "حساب خرید",
      },
      /*{
        path: "/user/stores",
        icon: "storefront",
        title: "لیست فروشگاه‌ها",
      },*/
      {
        path: "/user/stores/0000T7IJ680000000000000002/products",
        icon: "storefront",
        title: "سفارش از رستوران تعاونی",
      },
    ],
    ADMIN: [
      /*{
        path: "/admin/dashboard",
        icon: "dashboard",
        title: "داشبورد مدیریت",
      },*/
      {
        path: "/admin/users",
        icon: "group",
        title: "مدیریت کاربران",
      },
      {
        path: "/admin/notifications",
        icon: "notifications",
        title: "اعلان‌ها",
      },
      {
        path: "/admin/stores",
        icon: "receipt_long",
        title: "فروشگاه‌ها",
      },
      {
        path: "/admin/categories",
        icon: "group",
        title: "گروه کاربران",
      },
      {
        path: "/admin/merchant/categories",
        icon: "category",
        title: "دسته بندی مشاغل",
      },
      {
        path: "/admin/credit-requests",
        icon: "shopping_cart",
        title: "درخواستهای خرید",
      },
      {
        path: "/admin/transactions",
        icon: "receipt_long",
        title: "تراکنش‌ها",
      },
      {
        path: "/admin/purchase-accounts",
        icon: "account_balance_wallet",
        title: "حساب خرید",
      },
      {
        path: "/admin/product/categories",
        icon: "category",
        title: "دسته بندی محصولات",
      },
      {
        path: "/admin/products",
        icon: "inventory_2",
        title: "محصولات",
      },
      {
        path: "/admin/transactions/import",
        icon: "receipt_long",
        title: "ورود تراکنش توسط اکسل",
      },
      {
        path: "/admin/requests/import",
        icon: "upload_file",
        title: "ورود درخواست خرید (اکسل)",
      },
    ],
  };

  // اگر نقش تعریف نشده بود (مثلاً هنوز لاگین نکرده)
  const currentMenu = menuItems[role] || [];

  return (
    <> 
      <div className={`sidebar-area ${pathname === "/dashboard/beauty-salon" && isDark ? "dark" : ""}`}>
        <div className="logo position-relative">
          <div
            className="d-block text-decoration-none position-relative"
          >
            <Link
                  to='/'
                  className={`menu-link`}
                >
              <img
                src="/images/logo-icon.png"
                alt="logo-icon"
                width={26}
                height={26}
              />
              <span className="logo-text fw-bold text-dark">حساب اعتباری</span>
            </Link>
          </div>
          <button
            className="sidebar-burger-menu bg-transparent p-0 border-0 opacity-0 z-n1 position-absolute top-50 end-0 translate-middle-y"
            onClick={toggleActive}
          >
            <i className="material-symbols-outlined fs-24">close</i>
          </button>
        </div>

        <div className="sidebar-menu">
          <div className="menu-title small text-uppercase">
            <span className="menu-title-text">منوی اصلی</span>
          </div>

          <Accordion defaultActiveKey="0" flush>

            {currentMenu.map((item) => (
              <div className="menu-item" key={item.path}>
                <Link
                  to={item.path}
                  className={`menu-link ${
                    pathname === item.path ? "active" : ""
                  }`}
                >
                  <i className="material-symbols-outlined">{item.icon}</i>
                  <span className="title">{item.title}</span>
                </Link>
              </div>
            ))}

            {/* <Accordion.Item eventKey="29">
              <Accordion.Header>
                <i className="material-symbols-outlined">chat_error</i>
                <span className="title">صفحات خطا</span>
              </Accordion.Header>
              <Accordion.Body>
                <ul className="sub-menu">
                  <li className="menu-item">
                    <a
                      href="/not-found"
                      className={`menu-link ${
                        pathname === "/not-found" ? "active" : ""
                      }`}
                    >
                      خطا 404
                    </a>
                  </li>

                  <li className="menu-item">
                    <Link
                      to="/internal-error"
                      className={`menu-link ${
                        pathname === "/internal-error" ? "active" : ""
                      }`}
                    >
                      ارور داخلی
                    </Link>
                  </li>
                </ul>
              </Accordion.Body>
            </Accordion.Item> */}

            <div className="menu-item">
              <a
                href="/authentication/logout"
                className={`menu-link ${
                  pathname === "/authentication/logout" ? "active" : ""
                }`}
              >
                <i className="material-symbols-outlined">logout</i>
                <span className="title">خروج</span>
              </a>
            </div>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default LeftSidebar;
